import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ProductZoom from "../../components/ProductZoom";
import {
  useLazyPropertyBookingsQuery,
  useLazyPropertyServiceQuery,
  useLazyPropertyTransactionsQuery,
  useLazyPropertyViewQuery,
} from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";
import TopHeader from "../Dashoboard/TopHeader";
import GetTogether from "../Properties/GetTogether";
import RoomSharing from "../Properties/RoomSharing";
import RoomBooking from "../Room/RoomBooking";
import Bookings from "./Bookings";
import DayOuting from "./DayOuting";
import JustWalking from "./JustWalking";
import PropertyDetails from "./PropertyDetails";
import Transaction from "./Transaction";

const PropertyView = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [details, setDetails] = useState({});
  const [services, setServices] = useState([]);
  const [tab, setTab] = useState(1);

  //  BOOKINGS
  const [bookingCount, setBookingCount] = useState(1);
  const [paginationBooking, setPagonationBooking] = useState({});
  const [bookingPage, setBookingPage] = useState(1);
  const [bookingRow, setBookingRow] = useState(10);
  const [bookings, setBookings] = useState([]);

  //  TRANSACTION
  const [transactionCount, setTransactionCount] = useState(1);
  const [paginationTransaction, setPagonationTransaction] = useState({});
  const [transactionPage, setTransactionPage] = useState(1);
  const [transactionRow, setTransactionRow] = useState(10);
  const [transactions, setTransactions] = useState([]);
  const [transactionTotal, setTransactionTotal] = useState([]);
  const [transactionBalance, setTransactionBalance] = useState([]);

  //RTK QUERY
  const [propertyViewApi] = useLazyPropertyViewQuery();
  const [propertyBookings] = useLazyPropertyBookingsQuery();
  const [propertyTransactions] = useLazyPropertyTransactionsQuery();

  // DETAILS VIEW
  const getView = () => {
    propertyViewApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        setDetails(res);
        setServices(res?.services);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getView();
    }
  }, []);

  // BOOKING LIST
  const getBookings = (row) => {
    let params = `?page=${bookingPage}`;

    if (row) {
      params += `&row=${row}`;
    }

    setBookingRow(row);
    dispatch(saveLoader(true));
    propertyBookings({ id: location?.state?.data?.id, params: params })
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setBookings(res?.property_bookings);
        setBookingCount(
          Math.ceil(res?.pagination?.total / res?.pagination?.per_page)
        );
        setPagonationBooking(res?.pagination);
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getBookings(bookingRow);
    }
  }, [bookingPage]);

  // TRANSACTION LIST
  const getTransaction = (row) => {
    let params = `?page=${transactionPage}`;

    if (row) {
      params += `&row=${row}`;
    }

    setTransactionRow(row);
    dispatch(saveLoader(true));
    propertyTransactions({ id: location?.state?.data?.id, params: params })
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        let property_transaction_reports = [];
        res?.property_transaction_reports?.map((item) => {
          property_transaction_reports.push({
            ...item,
            id: item?.page_id,
          });
        });
        setTransactions(property_transaction_reports);
        setTransactionTotal(res?.total);

        let balances = [];
        for (var x = 0; x < res?.total?.length; x++) {
          balances.push({
            balance: res?.total[x],
          });
        }

        setTransactionBalance(balances);
        setTransactionCount(
          Math.ceil(res?.pagination?.total / res?.pagination?.per_page)
        );
        setPagonationTransaction(res?.pagination);
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getTransaction(transactionRow);
    }
  }, [transactionPage]);

  return (
    <div className="dashRightView home_section">
      <TopHeader type={"property-view"} />
      <div className=" block block-rounded ">
        <div className="block-content">
          <div className="nav-user mb-4" style={{ overflow: "auto" }}>
            <div className="presentation">
              <button
                className={`nav-presentation text-nowrap  ${
                  tab == 1 ? "pre-active" : ""
                }`}
                onClick={() => setTab(1)}
              >
                Details
              </button>
            </div>

            {services?.includes("room_booking") && (
              <div className="presentation">
                <button
                  className={`nav-presentation text-nowrap  ${
                    tab == 2 ? "pre-active" : ""
                  }`}
                  onClick={() => setTab(2)}
                >
                  Room Booking
                </button>
              </div>
            )}

            {services?.includes("day_outing") && (
              <div className="presentation">
                <button
                  className={`nav-presentation  text-nowrap ${
                    tab == 3 ? "pre-active" : ""
                  }`}
                  onClick={() => setTab(3)}
                >
                  Day Outing
                </button>
              </div>
            )}

            {services?.includes("just_walking") && (
              <div className="presentation">
                <button
                  className={`nav-presentation text-nowrap ${
                    tab == 4 ? "pre-active" : ""
                  }`}
                  onClick={() => setTab(4)}
                >
                  Just Walking
                </button>
              </div>
            )}

            {services?.includes("get_together") && (
              <div className="presentation">
                <button
                  className={`nav-presentation text-nowrap ${
                    tab == 5 ? "pre-active" : ""
                  }`}
                  onClick={() => setTab(5)}
                >
                  Get Together
                </button>
              </div>
            )}

            {services?.includes("room_sharing") && (
              <div className="presentation">
                <button
                  className={`nav-presentation text-nowrap ${
                    tab == 6 ? "pre-active" : ""
                  }`}
                  onClick={() => setTab(6)}
                >
                  Room Sharing
                </button>
              </div>
            )}

            {bookings?.length > 0 && (
              <div className="presentation">
                <button
                  className={`nav-presentation text-nowrap ${
                    tab == 14 ? "pre-active" : ""
                  }`}
                  onClick={() => setTab(14)}
                >
                  Bookings
                </button>
              </div>
            )}

            {transactions?.length > 0 && (
              <div className="presentation">
                <button
                  className={`nav-presentation text-nowrap  ${
                    tab == 13 ? "pre-active" : ""
                  }`}
                  onClick={() => setTab(13)}
                >
                  Transactions
                </button>
              </div>
            )}
          </div>
          <div>
            {tab == 1 && (
              <PropertyDetails details={details} getView={getView} />
            )}
            {tab == 2 && <RoomBooking details={details} getView={getView} />}
            {tab == 3 && <DayOuting list={details} getView={getView} />}
            {tab == 4 && <JustWalking list={details} />}
            {tab == 5 && <GetTogether list={details} />}
            {tab == 6 && <RoomSharing list={details} />}
            {tab == 14 && (
              <Bookings
                getBookings={getBookings}
                setBookingPage={setBookingPage}
                paginationBooking={paginationBooking}
                bookingCount={bookingCount}
                bookingRow={bookingRow}
                bookings={bookings}
              />
            )}

            {tab == 13 && (
              <Transaction
                getTransaction={getTransaction}
                setTransactionPage={setTransactionPage}
                paginationTransaction={paginationTransaction}
                transactionCount={transactionCount}
                transactionRow={transactionRow}
                transactions={transactions}
                transactionBalance={transactionBalance}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyView;
